import React from "react";

const Watch = () => {
  return (
    <div className="shoppage">
      <br></br>
      <div className="gallery">
        <iframe
          title="d"
          width="420"
          height="345"
          src="https://www.youtube.com/embed/LDnL-6F9n00"
        ></iframe>
        <iframe
          title="d"
          width="420"
          height="345"
          src="https://www.youtube.com/embed/1kplBptiZhc"
        ></iframe>
        <iframe
          title="d"
          width="420"
          height="345"
          src="https://www.youtube.com/embed/BCoo5P62vXo"
        ></iframe>
      </div>
    </div>
  );
};

export default Watch;
